import { type QueryFunctionContext } from "@tanstack/react-query";

export default async function getTrailerEmbed(context: QueryFunctionContext) {
    const videoId = context.queryKey[1];
    const r = await fetch("/film/trailerembed?vid=" + videoId);
    const eCode = await r.json() as { embedCode: string };

    return eCode.embedCode;
}